__turbopack_context__.v({
  "buttons": "CoreFormComponent-module-scss-module__NwBADW__buttons",
  "email-input": "CoreFormComponent-module-scss-module__NwBADW__email-input",
  "error": "CoreFormComponent-module-scss-module__NwBADW__error",
  "error-icon": "CoreFormComponent-module-scss-module__NwBADW__error-icon",
  "form": "CoreFormComponent-module-scss-module__NwBADW__form",
  "main": "CoreFormComponent-module-scss-module__NwBADW__main",
  "success": "CoreFormComponent-module-scss-module__NwBADW__success",
  "success-icon": "CoreFormComponent-module-scss-module__NwBADW__success-icon",
  "text-area": "CoreFormComponent-module-scss-module__NwBADW__text-area",
  "text-input": "CoreFormComponent-module-scss-module__NwBADW__text-input",
  "turnstile": "CoreFormComponent-module-scss-module__NwBADW__turnstile",
});
